module.exports = {"id":true,"reason":true,"status":true,"comments":true,"newDate":true,"resendOrder":true}


//////////////////
// WEBPACK FOOTER
// ./src/schemas/modules/supplierRejectionRules.json
// module id = zOAr
// module chunks = 4